import {
    LabelPosition,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IHrWizeSetupFieldsPanel {
}
export const HrWizeSetupFieldsPanel: FC<
    IHrWizeSetupFieldsPanel
> = ({ }) => {

    return (
        <>
            <RHookFormTextFieldWithLabel
                label="Api Key"
                id="api_key"
                testId={`api-key`}
                labelPosition={LabelPosition.Top}
            />
        </>
    );
};
